<template>
    <div>
        <div class="register-await-supplier" v-loading="loading">
            <m-pane
                v-if="!loading && tableShow"
                :config="config_"
                :totalData="totalData_"
                :pageTotal="pageTotal_"
                :loading="false"
                :searchTotalTitle="config_.searchTotalTitle"
                :currentPage="currentPage_"
                :initSearchInfo="awaitInitSearchInfo"
                searchId="keyData_"
                pageID="keyDataList_251031"
                @edit-btn="editBtn"
                @row-db-click="rowDBclick"
                @selectChange="selectChange"
                @searchChange="searchChange"
                @pageChange="pageChange"
                @sizeChange="sizeChange">
                <div slot="table-module-btn" class="btn-box">
                    <el-tooltip effect="dark" content="新增" placement="bottom" style="margin-left: 10px;">
                        <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAdd" v-has="'04000028'"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="导出" placement="bottom" style="margin-left: 10px;">
                        <el-button icon="el-icon-download" size="mini" :loading="exportLoading" @click="handleExport" v-has="'04000029'"></el-button>
                    </el-tooltip>
                    <!-- <el-tooltip effect="dark" content="刷新" placement="bottom" style="margin-left: 10px;">
                        <el-button icon="el-icon-refresh" size="mini" @click="handleRefresh"></el-button>
                    </el-tooltip> -->
                </div>
            </m-pane>
        </div>
        <add-or-edit-dialog
            :openAddOrEditDialog="openAddOrEditDialog"
            :overseaSwitch="overseaSwitch"
            @closeDialog="closeAddOrEditDialog"
            @confirmDialog="confirmAddOrEditDialog">
        </add-or-edit-dialog>
    </div>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import mPane from '../../../../components/Panel.vue';
import config_ from './configPending.js';
import addOrEditDialog from './AddOrEditDialog.vue';
import { dictWithUrl } from '@/components/lots/api';
import { getAwaitSupplierList, exportListData } from '../../../../api/register/supplierList.js';
import { COMPANY, OS_LGT } from '../../../../constant/constant.js';
export default {
    name: '',
    components: { mPane, addOrEditDialog },
    props: {
        classify: {
            type: String,
            default: ''
        },
        overseaSwitch: {
            type: Boolean,
            default() {
                return true;
            }
        },
        tableShow: {
            type: Boolean,
            default() {
                return false;
            }
        },
    },
    data() {
        return {
            config_,
            pageTotal_: 0,
            totalData_: [],
            searchObj_: {
                pageNo: 1,
                pageSize: 10,
                orderByType: 'desc'
            },
            currentPage_: 1,
            searchQuery: {},
            openAddOrEditDialog: false,
            exportParams: {},
            PENDINGSUPPLIERS: '待处理供应商',
            awaitInitSearchInfo: this.$store.state.awaitInitSearchInfo,
            loading: false,
            exportLoading: false
        };
    },
    created() {
        // this.handleGetAwaitSupplierList();
        // this.searchChange(this.awaitInitSearchInfo);
    },
    methods: {
        load() {},
        editBtn() {},
        rowDBclick(row) {
            this.$router.push({
                path: '/keyData/detail',
                query: {
                    id: row.id,
                    businessType: row.businessType,
                    supplierCode: row.supplierCode,
                    businessTypeId: row.businessTypeId,
                    propertyNature: row.propertyNature
                }
            });
        },
        searchChange(data) {
            this.currentPage_ = 1;
            // this.searchQuery = data;
            this.handleGetAwaitSupplierList(data);
            // this.$store.commit('setAwaitInitSearchInfo', data);
        },
        pageChange(data) {
            this.currentPage_ = data;
            this.handleGetAwaitSupplierList();
        },
        selectChange() {},
        sizeChange(data) {
            this.config_.page.pageSize = data;
            this.currentPage_ = 1;
            this.handleGetAwaitSupplierList();
        },
        selectClassify() {},
        handleAdd() {
            this.openAddOrEditDialog = true;
        },
        handleExport() {
            delete this.exportParams.pageNo;
            delete this.exportParams.pageSize;
            this.$confirm('是否确定导出?', '导出确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.exportLoading = true;
                exportListData(JSON.stringify(this.exportParams)).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data || '文件处理中，稍后请留意右上角文件中心下载文件！')
                    }
                }).finally(() => { this.exportLoading = false; });
            });
        },
        // handleRefresh() {
        //     this.searchChange(this.searchQuery);
        // },
        handleGetAwaitSupplierList(searchQuery) {
            const searchParams = {};
            if (searchQuery) {
                this.searchQuery = searchQuery;
                this.$store.commit('setAwaitInitSearchInfo', searchQuery);
            }
            _.forIn(this.searchQuery, function(value, key) {
                if (value instanceof Array) {
                    searchParams[key] = value.join(',');
                } else {
                    searchParams[key] = value;
                }
            });
            if (searchParams.createTimeArr) {
                const startTime = searchParams.createTimeArr.split(',')[0];
                const endTime = searchParams.createTimeArr.split(',')[1];
                if (dayjs(endTime).subtract(1, 'month').subtract(1, 'day') > dayjs(startTime)) {
                    this.$message.warning('时间区间不能大于一个月');
                    return;
                }
                searchParams.createTimeArr = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss') + ',' + dayjs(endTime).format('YYYY-MM-DD HH:mm:ss');
            } else if (
                searchParams.propertyNature !== COMPANY &&
                searchParams.isOverseas !== OS_LGT &&
                !searchParams.supplierCode &&
                !searchParams.supplierNameCn &&
                !searchParams.supplierCodeGroup &&
                !searchParams.idCard
            ) {
                // 主体性质不是法人时，供应商编码、供应商名称、集团编号、身份证号、时间不能同时为空
                this.$message.warning('供应商编码、供应商名称、集团编号、身份证号、时间不能同时为空');
                return;
            }
            let params = { pageNo: this.currentPage_, pageSize: this.config_.page.pageSize };
            params = { ...params, ...searchParams };
            params.orderByType = 'desc';
            params.queryFlag = '1';
            this.exportParams = params;
            getAwaitSupplierList(params).then(res => {
                if (res && +res.code === 0) {
                    this.totalData_ = this.formatData(res.data.list);
                    this.pageTotal_ = res.data.totalCount;
                    this.currentPage_ = res.data.pageNo;
                    this.loading = false;

                    this.$store.commit('setAwaitInitPageInfo', { currentPage: this.currentPage_, pageSize: this.config_.page.pageSize });
                }
            }).catch(e => { this.loading = false; });
        },
        closeAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
        },
        confirmAddOrEditDialog(data) {
            this.openAddOrEditDialog = data;
        },
        formatData(data) {
            return data.map(item => {
                item.supplierStatus = this.dict.SYS_SUPPLIERS_STATUS[item.supplierStatus];
                item.propertyNature_ = this.dict.SYS_SUPPLIERS_PROPERTY[item.propertyNature];
                item.isOverseas_ = this.dict.SRM_IS_OVERSEAS[item.isOverseas];
                item.businessType_ = this.dict.SRM_BUSYNESS_TYPE_BACKGROUND[item.businessType];
                item.businessTypeStatus_ = this.dict.SYS_SUPPLIER_SERVICES_STATUS[item.businessTypeStatus];
                item.transType = this.dict.SRM_SHIPPER_TYPE[item.transType];
                item.corporateType = this.dict.SU_CORPORATE_TYPE[item.corporateType];
                item.transportType = this.dict.SRM_TRANSPORT_TYPE[item.transportType];
                item.lesseeType = this.dict.SU_LEASE_TYPE[item.lesseeType];
                item.updateFlag = this.dict.SRM_CHANGE_FLAG[item.updateFlag];
                item.blackFlag = this.dict.SRM_BLACK_FLAG[item.blackFlag];
                item.specialFlag = this.dict.SRM_SPECIAL_FLAG[item.specialFlag];
                item.qualityIsComplete = this.dict.SRM_QUALITY_FLAG[item.qualityIsComplete];
                item.rectifyFlag = this.dict.SRM_RECTIFICATION_TYPE[item.rectifyFlag];
                return item;
            });
        },
        initTime() {
            const startTime = dayjs().startOf('day').subtract(1, 'M').format('YYYY-MM-DD HH:mm:ss');
            const endTime = dayjs(new Date()).endOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.awaitInitSearchInfo.createTimeArr = [startTime, endTime];
        }
    },
    watch: {
        classify: {
            handler(nVal) {
                if (nVal === this.PENDINGSUPPLIERS) {
                    const { currentPage, pageSize } = this.$store.state.awaitInitPageInfo;
                    this.currentPage_ = currentPage;
                    this.config_.page.pageSize = pageSize;
                    this.loading = true;
                    this.initTime();
                    this.handleGetAwaitSupplierList(this.awaitInitSearchInfo);
                }
            },
            immediate: true
        },
        // 表格显示后根据overseaSwitch开关调整配置文件
        tableShow(val) {
            if (val) {
                const configTemp = JSON.parse(JSON.stringify(config_))
                if (!this.overseaSwitch) {
                    configTemp.searchList.searchTxt = configTemp.searchList.searchTxt.filter(item => item.value !== 'isOverseas')
                    configTemp.table.columns = configTemp.table.columns.filter(item => item.prop !== 'isOverseas_')
                }
                this.config_ = configTemp
            }
        },
    },
    mounted() {
        dictWithUrl('SYS_SUPPLIERS_STATUS,SYS_SUPPLIERS_PROPERTY,SRM_IS_OVERSEAS,SRM_BUSYNESS_TYPE_BACKGROUND,SRM_SHIPPER_TYPE,SYS_SUPPLIER_SERVICES_STATUS,' +
            'SU_CORPORATE_TYPE,SRM_TRANSPORT_TYPE,SU_LEASE_TYPE,SRM_CHANGE_FLAG,SRM_BLACK_FLAG,SRM_SPECIAL_FLAG,SRM_QUALITY_FLAG,SRM_RECTIFICATION_TYPE').then(res => {
            this.dict = res.data;
        });
    }
};
</script>

<style lang="less">
.register-await-supplier {
    // min-height: 200px;
    div#mPane3 .el-table {
        min-height: calc(100vh - 230px);
        max-height: calc(100vh - 230px);
    }
}
</style>